import React from "react";

import { useSelector } from "react-redux";
import parse from "html-react-parser";

import { RIGHT_OF_WITHDRAWAL_MODEL } from "../../models/model";
import { Modal } from "@/components/molecules/NewModal";
import helpers from "@/utils/helpers";
import { APP_KEY_ENCRYPT } from "@/utils/awsConfig";
import { encrypt_AES256_2 } from '@/utils/CryptographyUtils';

import "./styles.scss";

export const ModalRightOfWithdrawal = ({ isOpen, onClose }) => {
  const { content } = RIGHT_OF_WITHDRAWAL_MODEL;
  const { userData } = useSelector((state) => state.vida);

  const getTracking = (label) => {
    helpers.getTagAction(
      "Seguro Vida Devolución Garantizada",
      "Resumen y pago",
      "Modal condiciones",
      label,
      "trackAction"
    )
  };

  const validateLinkEmail = (data) => data && data[0].data.includes("atencionalcliente");

  const handleHyper = (e, children, link) => {
    const isLinkToEmail = validateLinkEmail(children);
    const email = "atencionalcliente@rimac.com.pe";
    if (isLinkToEmail) {
      getTracking(email);
      if (userData.indPrevPageApp) {
        const message = `EMBEDDED-APP-HIPERVINCULO : {"accion": "EMAIL", "valor": "${email}", "mensaje": ""}`;
        const encryptedMessage = encrypt_AES256_2(message, APP_KEY_ENCRYPT);
        return helpers.sendMessageToApp(encryptedMessage);
      }
    }
    e.preventDefault();
    window.open(link, "_blank", "noopener noreferrer");
  };

  const formatHtml = (description) => {
    if (!description) return "";
    const options = {
      replace: (domNode) => {
        if (domNode.type === "tag" && domNode.name === "a") {
          const href = domNode.attribs.href;
          return (
            <button type="button" onClick={(e) => handleHyper(e, domNode.children, href)}>
              {domNode.children.map((child) => {
                if (child.type === "text") {
                  return child.data;
                }
                return null;
              })}
            </button>
          );
        }
      },
    };

    return parse(description, options);
  };

  return (
    <Modal
      isOpen={isOpen}
      fullContentOnlyMobile
      onClose={onClose}
      className="col-span-full lg:col-span-8 lg:col-start-3"
      classNameGrid="max-h-dvh overflow-y-auto custom-scroll lg:max-h-auto lg:overflow-y-hidden"
    >
      <div className="modal-rofwd">
        <div className="flex flex-col custom-scroll gap-9">
          {content.map((item, index) => (
            <div key={`item-${index}`} className="modal-rofwd_item">
              <h3>{item.title}</h3>
              {item.paragraphs.map((paragraph, index) => (
                <p key={`item-p-${index}`}>{formatHtml(paragraph)}</p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};
